module.exports = __webpack_public_path__ + "02_long_brown.30f28a85.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/girl/layer5/02_long_brown.png
// module id = cYyE
// module chunks = 0